<script>
	/*
		TCareNumber.svelte
	*/


	export let source;
	export let prop;
	export let setValue;
	
	const _onKeyUp = (e) => {
		setValue(source, prop, e.target.value);
	}

</script>

<style>
	/* in tcare-ui.css */
</style>

<div class="tcui-control flex-row">
	<input type="number" class="number" value={source[prop]} on:keyup={_onKeyUp}/>
</div>
